/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Help.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Help: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18" ref={ref} {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M9 2.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5M.75 9a8.25 8.25 0 1 1 16.5 0A8.25 8.25 0 0 1 .75 9m8.444-2.982a1.5 1.5 0 0 0-1.669.98.75.75 0 1 1-1.415-.497 3 3 0 0 1 5.83 1c0 1.147-.851 1.905-1.459 2.31a6 6 0 0 1-1.264.637l-.026.009-.009.003H9.18v.001c-.001 0-.002 0-.239-.711l.237.711a.75.75 0 0 1-.475-1.422l.012-.004.056-.021c.05-.02.126-.05.217-.09.185-.082.426-.203.662-.36.517-.345.791-.712.791-1.064v-.001a1.5 1.5 0 0 0-1.246-1.48M9 13.5A.75.75 0 1 0 9 12a.75.75 0 0 0 0 1.5"
      clipRule="evenodd"
    />
  </svg>
);
Help.displayName = "Help";
